Bingo.PreviewTable = {};

Bingo.PreviewTable.init = () => {
    $(document).on('click', '.js-previewTable__openMore', function (e) {
        e.preventDefault();
        const row = $(this).closest('.js-previewTable__row');
        const hiddenContent = row.find('.js-previewTable__hiddenContent');
        const openButton = row.find('.A-button.js-previewTable__openMore');
        const openCircle = row.find('.A-circle.js-previewTable__openMore');
        if (hiddenContent.hasClass('-opened')) {
            openCircle.removeClass('-opened');
            openButton.text(openButton.attr('data-show-text'));
            hiddenContent.removeClass('-opened').slideUp('slow');
            row.removeClass('-opened');
        } else {
            openCircle.addClass('-opened');
            openButton.text(openButton.attr('data-hide-text'));
            hiddenContent.addClass('-opened').slideDown('slow');
            row.addClass('-opened');
        }
    });
};
